/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect } from 'react';

const EmailRequest = () => {
  const domain = window.location.href;
  
  const getDomain = () => {
    if(domain.includes('localhost'))  {
      return `http://localhost:3003/company/0a6ad683-2f62-4d97-8ea8-449116dd4cab/form-validate?tkn=cbec9b85-b9a5-4c17-a850-dd1cdab7a231`;
    }
    if(domain.includes('rockerbox-dev.rockerbox.tech'))  {
      return `https://rockerbox-dev.rockerbox.tech/company/0a6ad683-2f62-4d97-8ea8-449116dd4cab/form-validate?tkn=cbec9b85-b9a5-4c17-a850-dd1cdab7a231`;
    }
    if(domain.includes('rockerbox-stg')){
      return `https://rockerbox-stg.rockerbox.tech/company/f3a36230-4a9d-46c1-8e12-082efc3f174a/form-validate?tkn=1c299748-2a75-40a4-8d97-8493bacf8739`;
    }
    return `https://app.rockerbox.tech/company/d3856729-7ca1-46f0-9bc4-79ada0af8664/form-validate?tkn=6aa02461-320b-4c20-a65f-a65601a81dbd`;
  }

  useEffect(() => {
    window.location.href = getDomain();
  }, [domain])
 
  return (
    <>
    
    </>
  )
};

export default EmailRequest;